import * as React from 'react';

import { sumBy } from 'lodash';

/**
 * Interface for estimated items that supports both snake_case (Angular)
 * and camelCase (GraphQL) naming conventions for future compatibility
 */
interface EstimatedItem {
  quantity: number;
  category_display_name?: string;
  categoryDisplayName?: string;
  dimensions_overwritten?: boolean;
  dimensionsOverwritten?: boolean;
  length?: number;
  width?: number;
  height?: number;
  notes?: string;
  cuft: string | number;
}

interface EstimatedItemListProps {
  entries: EstimatedItem[];
}

export const EstimatedItemList: React.FC<EstimatedItemListProps> = ({ entries }) => {
  const formatItemText = (entry: EstimatedItem): string => {
    const categoryDisplayName = entry.categoryDisplayName || entry.category_display_name || '';
    const dimensionsOverwritten = entry.dimensionsOverwritten || entry.dimensions_overwritten;

    let text = `${entry.quantity} × ${categoryDisplayName}`;

    if (dimensionsOverwritten) {
      text += ` (${entry.length}" x ${entry.width}" x ${entry.height}")`;
    }

    if (entry.notes && entry.notes.length) {
      text += `: ${entry.notes}`;
    }

    return text;
  };

  const calculateTotalCuft = (): number => {
    return sumBy(entries, (entry) => parseFloat(String(entry.cuft)) * entry.quantity || 0);
  };

  return (
    <div className="estimated-item-list">
      {entries.map((entry, index) => (
        <div key={index} className="estimated-item-entry">
          <span>{formatItemText(entry)}</span>
        </div>
      ))}
      <div className="estimated-item-list-total">
        <em>
          Total: {calculateTotalCuft().toFixed(2)} ft<sup>3</sup>
        </em>
      </div>
    </div>
  );
};
